<mat-card class="card">
  <iris-card-header>
    <ng-content select="header"></ng-content>
  </iris-card-header>

  <iris-card-body>
    <ng-content select="body"></ng-content>
  </iris-card-body>

  <iris-card-footer>
    <ng-content select="footer"></ng-content>
  </iris-card-footer>
</mat-card>
